export default __webpack_public_path__ + "images/1b122484d8c6549db60d0a3e77a33a9e-opera.webp";